import styled from 'styled-components';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { CUSTOMER_FEEDBACK_SURVEYS, DEAL_TAGS, KNOWLEDGE_BASE, TICKET_TAGS } from 'self-service-api/constants/Features';
import { API_LIMITED_ACCESS, API_NO_ACCESS } from 'self-service-api/constants/FreeUserAccessValues';
import HubMap from 'self-service-api/constants/HubMap';
import { productLineToHub } from 'self-service-api/constants/ProductLineToHub';
import * as PurchaseTypes from 'self-service-api/constants/PurchaseTypes';
import { Flex } from 'foundations-components/components/Flex';
import { getProductLineFromApiNameString } from '../_core/features/FeaturesUtils';
import FeatureTableCell from './FeatureTableCell';
import FeatureTableUserIcon from './FeatureTableUserIcon';
import TranslatedFeature from './TranslatedFeature';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const seatsFreeUserAccessLevelOverrides = {
  [KNOWLEDGE_BASE]: API_NO_ACCESS,
  [CUSTOMER_FEEDBACK_SURVEYS]: API_NO_ACCESS,
  [DEAL_TAGS]: API_NO_ACCESS,
  [TICKET_TAGS]: API_NO_ACCESS
};
const StyledFeatureRow = styled.tr.withConfig({
  displayName: "FeatureRow__StyledFeatureRow",
  componentId: "ilhcdj-0"
})(({
  theme,
  rowIsVisible
}) => {
  return {
    borderBottom: `${theme.borderWidth['100']} solid ${theme.color['border-core-default']}`,
    visibility: rowIsVisible ? 'visible' : 'hidden',
    display: 'table',
    width: '100%',
    tableLayout: 'fixed'
  };
});
const StyledHeaderCell = styled.th.withConfig({
  displayName: "FeatureRow__StyledHeaderCell",
  componentId: "ilhcdj-1"
})(({
  theme
}) => {
  return {
    paddingRight: theme.space['300'],
    paddingTop: theme.space['300'],
    paddingBottom: theme.space['300'],
    textAlign: 'left'
  };
});
const TranslatedFeatureWrapper = styled.div.withConfig({
  displayName: "FeatureRow__TranslatedFeatureWrapper",
  componentId: "ilhcdj-2"
})(({
  theme
}) => {
  return {
    fontWeight: theme.typography['body-100'].fontWeight,
    textDecorationLine: 'underline',
    textDecorationStyle: 'dashed',
    textUnderlinePosition: 'under',
    textDecorationThickness: '1px'
  };
});
const FeatureRow = ({
  feature,
  apiNames,
  canViewNewSeats,
  onlyShowCurrentLongLimit = false,
  rowIsVisible
}) => {
  const accessLevel = canViewNewSeats && seatsFreeUserAccessLevelOverrides[feature.shortName] || feature.freeUserAccessLevel;
  const API_NAMES_WITHOUT_PRODUCT_LINES = ['crm-suite-starter-bundle', 'hubspot-free', 'breeze-intelligence-credits-100', 'breeze-intelligence-credits-1000', 'breeze-intelligence-credits-10000', 'core-seats-free',
  // doesn't exist in merchandise/products response, but does exist in feature store
  'core-seats-starter', 'core-seats-professional', 'core-seats-enterprise'];
  const featureProductLinesFromApiNames = feature.productApiNames.map(apiName => {
    if (API_NAMES_WITHOUT_PRODUCT_LINES.includes(apiName)) {
      return undefined;
    }
    try {
      return getProductLineFromApiNameString(apiName);
    } catch (error) {
      return undefined;
    }
  });
  const productLine = featureProductLinesFromApiNames.find(localProductLine => {
    if (localProductLine && HubMap[productLineToHub[localProductLine]].merchPurchaseType === PurchaseTypes.SEAT_BASED) {
      return localProductLine;
    }
    return false;
  });
  const showUserIcon = productLine !== undefined && (accessLevel === API_LIMITED_ACCESS || accessLevel === API_NO_ACCESS);
  return /*#__PURE__*/_jsxs(StyledFeatureRow, {
    rowIsVisible: rowIsVisible,
    children: [/*#__PURE__*/_jsx(StyledHeaderCell, {
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [showUserIcon && /*#__PURE__*/_jsx(Flex, {
          marginInlineEnd: "100",
          children: /*#__PURE__*/_jsx(FeatureTableUserIcon, {
            freeUserAccess: accessLevel,
            productLine: productLine,
            canViewNewSeats: canViewNewSeats
          })
        }), /*#__PURE__*/_jsx(TranslatedFeatureWrapper, {
          tabIndex: -1,
          children: /*#__PURE__*/_jsx(Tooltip, {
            use: "longform",
            title: /*#__PURE__*/_jsx(TranslatedFeature, {
              feature: feature,
              attribute: "description"
            }),
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsx(TranslatedFeature, {
                feature: feature,
                attribute: "name"
              })
            })
          })
        })]
      })
    }), apiNames && apiNames.map(apiName => {
      return /*#__PURE__*/_jsx(FeatureTableCell, {
        feature: feature,
        apiName: apiName,
        onlyShowCurrentLongLimit: onlyShowCurrentLongLimit
      }, `${feature.featureId}-${feature.displayName}-${apiName}`);
    })]
  }, feature.featureId);
};
export default FeatureRow;